import { Component, OnInit } from '@angular/core';
import { RouterModule, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import Swal from 'sweetalert2';
import { AppServiceService } from '../../app-service.service';
declare var $;
@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss']
})

export class SigninComponent implements OnInit {
  public code;
  public loginForm: FormGroup;
  public forgetPasswordForm: FormGroup;
  public submitted = false;
  public forgetSubmitted = false;
  public rememberMe = false;
  public loading = false;
  public recaptcha: any[];

  constructor(public router: Router, public formBuilder: FormBuilder, public appService: AppServiceService) { }

  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      userName: ['', [Validators.required]],
      password: ['', [Validators.required]]
    });

    this.forgetPasswordForm = this.formBuilder.group({
      userName: ['', [Validators.required, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$')]],
    });

    
    if (localStorage.getItem('EmailId')) {
      let emailId = this.appService.decryptData(localStorage.getItem('EmailId'));
      emailId = emailId.replace(/['",<>\{\}\[\]\\\/]/gi, '');
      if (emailId) {
        $('#rememberMe').prop('checked', true);
        this.loginForm = this.formBuilder.group({
          userName: [emailId, [Validators.required]],
          password: ['', [Validators.required]]
        });
      }
    }
  }
  ngAfterViewInit() {
    const jsonData = localStorage.getItem('AdminDetails1');
    const appSetting = JSON.parse(jsonData);
    //alert(appSetting);
    if(appSetting.Status === 1){
      const adminDetails = this.appService.encryptData(appSetting);
      //alert(adminDetails);
      localStorage.setItem('AdminDetails', adminDetails);
      localStorage.removeItem('AdminDetails1');
           this.loading = false;
          this.router.navigate(['/Admin/SignIn-Log']);
    }
  }

  saveLogInInfo() {
    if ($('#rememberMe').is(':checked')) {
      this.rememberMe = true;
    } else {
      this.rememberMe = false;
    }
  }

  resolved(captchaResponse: any[]) {
    this.recaptcha = captchaResponse;
  }

  clickeye() {
    const password = document.querySelector('#id_password');
    const type = password.getAttribute('type') === 'password' ? 'text' : 'password';
    password.setAttribute('type', type);
  }

  onSubmit(formValues) {
    this.submitted = true;
    if (this.loginForm.invalid) {
      return;
    }

    if (this.recaptcha === undefined) {
      Swal.fire('', 'Invalid Captcha. Try Again', 'info');
    } else if ((formValues.userName !== '') && (formValues.password !== '')) {
      const postJson = {
        UserName: formValues.userName,
        Password: formValues.password
      };

      const url = this.appService.serviceURL + 'ValidateUserLogin';
      this.loading = true;
      this.appService.postData(url, postJson).subscribe(data => {
        if (data.status === 0) {
          $('#error_msg').show(); 
          this.loading = false;

        }else if(data.status == 3){
          this.loading = false;
          Swal.fire('', 'Patient Sign in application license for '+ data.clinic_name + ' is expired, Please reach out to your Business Admin('+data.Email_id+') to renew the license', 'info');
        } else {
           const adminDetails = this.appService.encryptData(data);
          console.log(data);
        //alert(data); 
          if (this.rememberMe) {
            localStorage.setItem('EmailId', this.appService.encryptData(formValues.userName));
          } else {
            if (localStorage.getItem('EmailId')) {
              localStorage.removeItem('EmailId');
            }
          }
          if(data.user_role == 2){
            localStorage.removeItem('AdminDetails');
          // alert(data.user_role);
          this.loading = false;
            window.location.href = this.appService.serviceURL + data.ClientId;
          }else{
            //window.location.href = this.appService.apiCsaUrl + data.ClientId;
          localStorage.removeItem('AdminDetails');
          localStorage.setItem('AdminDetails', adminDetails);
         // localStorage.setItem('AdminDetails1', JSON.stringify(data));
          this.loading = false;
          this.router.navigate(['/Admin/SignIn-Log']);
          }
        }
      });
    }
  }

  bindValue() {
    if ($('#userName').val() !== '') {
      $('#forgetId').val($('#userName').val());
      this.forgetPasswordForm = this.formBuilder.group({
        userName: [$('#userName').val(), [Validators.required, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$')]],
      });
     } else {
       $('#forgetId').val('');
    }
  }

  forgetPassword(formValue) {
    this.forgetSubmitted = true;
    if (this.forgetPasswordForm.invalid) {
      return;
    }

    const postJson = {
      EmailId: formValue.userName
    };

    const url = this.appService.serviceURL + 'CheckValidCsaEmail';
    this.appService.postData(url, postJson).subscribe(data => {
        if (data.Status === '0') {
          Swal.fire('', data.Message, 'error');
        } else if (data.Status === '1') {
          Swal.fire('', data.Message, 'success').then((result) => {
            $('#forgetPasswordModal').modal('toggle');
          });
        }
    });
  }

  clearData() {
    this.forgetSubmitted = false;
    $('#forgetId').val('');
    this.forgetPasswordForm = this.formBuilder.group({
      userName: ['', [Validators.required, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$')]],
    });
  }
}
